import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdPhotoLibrary } from "react-icons/md";
import s1 from "../assets/image19.jpeg";
import s2 from "../assets/image6.jpeg";
import s3 from "../assets/image7.jpeg";
import s4 from "../assets/image16.jpeg";
import s5 from "../assets/image40.jpeg";
import s6 from "../assets/image18.jpeg";
import s7 from "../assets/image11.jpeg";
import s8 from "../assets/banner9.png";
import s9 from "../assets/image22.jpeg";

import {
  FaImages,
  FaThLarge,
  FaUsers,
  FaLaptopCode,
  FaGraduationCap,
} from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneGallery from "./OneGallery";

export default function GalleryBanner(props) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [galleryList, setGalleryList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");

  // DATA YA MATUKIO NA PICHA (8 PREMIUM STATIC ITEMS)
  const staticGalleryData = [
    {
      uuid: "gal-001",
      title: "Mkutano Mkuu wa Mwaka wa Wanachama",
      coverPhoto: s1,
      category: "Mikutano",
      dateCreated: "2024",
    },
    {
      uuid: "gal-002",
      title: "Baadhi ya wanachama ambao ni mume na mke (couple) ndani ya YCSC SACCOS. Tabasamu la mtu na mweza wake. Ikumbukwe kuwa kila mwanachama ana haki sawa ndani ya chama.",
      coverPhoto: s2,
      category: "Teknolojia",
      dateCreated: "2024",
    },
    {
      uuid: "gal-003",
      title: "Eneo la Mkutano mkuu wa YCSC SACCOS LIMITED 2022 ilikua ni EPLAS",
      coverPhoto: s3,
      category: "Mafunzo",
      dateCreated: "2022",
    },
    {
      uuid: "gal-004",
      title: "Mwenyekiti wa Bodi akitoa maelezo au ripoti fupi siku ya sherehe za mwisho wa mwaka 2024",
      coverPhoto: s4,
      category: "Uongozi",
      dateCreated: "2024",
    },
    {
      uuid: "gal-005",
      title: "Utoaji wa Tuzo kwa Wawekaji Akiba Bora",
      coverPhoto: s5,
      category: "Matukio",
      dateCreated: "2025",
    },
    {
      uuid: "gal-006",
      title: "Wadada wa YCSCS SACCOS wakiendelea kujipatia kifungua kinywa sherehe ya mwisho wa mwaka 2024",
      coverPhoto: s6,
      category: "Matukio",
      dateCreated: "2024",
    },
    {
      uuid: "gal-007",
      title: "Sherehe za Maadhimisho ya Miaka ya Ukuaji",
      coverPhoto: s7,
      category: "Matukio",
      dateCreated: "2024",
    },
    {
      uuid: "gal-008",
      title: "Picha ya pamoja 2024 ",
      coverPhoto: s8,
      category: "Ukuaji",
      dateCreated: "2024",
    },
  ];

  // Kategoria za Kujenga Tab za Kujichuja (Inalingana na muundo wa Newsroom tabs)
  const categories = [
    { name: "All", label: "Zote", icon: <FaThLarge /> },
    { name: "Mikutano", label: "Mikutano", icon: <FaUsers /> },
    { name: "Teknolojia", label: "Teknolojia", icon: <FaLaptopCode /> },
    { name: "Mafunzo", label: "Mafunzo", icon: <FaGraduationCap /> },
    { name: "Matukio", label: "Matukio", icon: <FaImages /> },
  ];

  async function init() {
    setReady(false);

    /* ==================================================================
    DYNAMIC PARTS (COMMENTED OUT FOR FUTURE API INTEGRATION)
    ==================================================================
    try {
      await Promise.all([
        appContext.getAllGallery(),
      ]);
      if (appContext.allGallery && appContext.allGallery.length > 0) {
        setGalleryList(appContext.allGallery);
        setFilteredList(appContext.allGallery);
      }
    } catch (error) {
      console.error("Error fetching dynamic gallery:", error);
    }
    ==================================================================
    */

    setGalleryList(staticGalleryData);
    setFilteredList(staticGalleryData);
    setReady(true);
  }

  // Kushughulikia uchujaji wa picha pindi tab inapobonyezwa
  const handleCategoryChange = (categoryName) => {
    setActiveCategory(categoryName);
    if (categoryName === "All") {
      setFilteredList(galleryList);
    } else {
      const filtered = galleryList.filter(
        (item) => item.category === categoryName,
      );
      setFilteredList(filtered);
    }
  };

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div className="ycsc-gallery-main-section py-5 animate__animated animate__fadeIn">
        <div className="container">
          {/* CATEGORY FILTER TABS (Consistent with Newsroom Navigation) */}
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="col-md-8">
                <div className="d-flex align-items-center gap-2 text-primary">
                  <MdPhotoLibrary className="text-warning fs-4" />
                  <span className="premium-accent-kicker m-0">
                    Picha na Kumbukumbu
                  </span>
                </div>
                <h2 className="premium-section-title mt-1">
                  Matunzio mbalimbali
                </h2>
              </div>
              {/* <div className="gallery-filter-wrapper d-flex flex-wrap justify-content-center gap-2 p-2 rounded-4 shadow-sm bg-white">
                {categories.map((cat, idx) => (
                  <button
                    key={idx}
                    className={`btn gallery-filter-btn d-flex align-items-center gap-2 px-4 py-2 rounded-3 border-0 transition-all ${
                      activeCategory === cat.name
                        ? "bg-primary text-white shadow-sm fw-bold"
                        : "text-secondary hover-bg-light"
                    }`}
                    onClick={() => handleCategoryChange(cat.name)}
                  >
                    {cat.icon}
                    <span>{cat.label}</span>
                  </button>
                ))}
              </div> */}
            </div>
          </div>

          {/* GRID LAYOUT FOR ONEGALLERY CARDS */}
          <div className="row g-4">
            {filteredList.length > 0 ? (
              filteredList.map((item, i) => {
                return (
                  <div
                    key={item.uuid || i}
                    className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 animate__animated animate__fadeInUp"
                  >
                    <OneGallery data={item} />
                  </div>
                );
              })
            ) : (
              <div className="col-md-12 text-center py-5">
                <div className="empty-gallery-state py-4">
                  <FaImages className="text-muted display-4 mb-3 opacity-50" />
                  <h5 className="text-secondary">
                    Hakuna picha zilizopatikana
                  </h5>
                  <p className="text-muted small">
                    Jaribu kuchagua kategoria nyingine ya matukio.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* BOTTOM ACCENT: Beautiful Horizontal Image Strip */}
        <div className="mt-5 pt-5">
          <HorizontalImageStrip images={[s1, s2, s3, s4, s5, s6, s7, s8, s9]} />
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading text-center py-5">
        {getInlineLoader()}
      </div>
    );
  }
}
